import React, { useEffect, useState } from "react";
import "./FeaturedCard.css";
import { Button } from "../Button";
import useCustomTranslation from "../../utils/useCustomTranslation";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import { getTargetFromType, useGetLink } from "../../utils/useOpenLink";
import parse from "html-react-parser";
import CustomLink from "../../utils/customLink";
import ImageWithObjectFit from "../ImageWrapperComponent";
import useGetArticleMeta from "../../utils/useGetArticleMeta";
import { Link } from "react-router-dom";
import { APP_COLORS } from "../../constants/styles";

function FeaturedCard({ contents: contentToRender = [], heading, colors: colorObj }) {
    const { direction } = useCustomTranslation();

    const [contentReferenceData, setContentReferenceData] = useState([]);

    const content = useSelector((state) => state.layout.content);

    const { getLink } = useGetLink();

    const { getTheme } = useGetArticleMeta();

    useEffect(() => {
        const fetchDefaultData = () => {
            const resp = content[contentToRender[0].contentKey].map((k) => content[k]);

            if (resp.length) {
                setContentReferenceData(resp);
            }
        };
        fetchDefaultData();
    }, []);

    const swiperCarousel = {
        spaceBetween: 10,
        slidesPerView: 2.3,
        modules: [Pagination, Navigation],
        pagination: { clickable: true, dynamicBullets: true, dynamicMainBullets: 7 },
        navigation: true,
        breakpoints: {
            768: {
                slidesPerView: 1.3,
                spaceBetween: 20,
            },
        },
    };

    return (
        <>
            <div className="featuredCardSection py-50" style={APP_COLORS(colorObj)}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-lg-4 col-sm-12 col-12">
                            <div className="textMainHldr">
                                <div className="heading">{heading}</div>
                                <div className="sub-heading">{contentToRender[0]?.heading}</div>
                                <div
                                    className="content-body"
                                    style={{ color: colorObj?.accent_color1 }}
                                >
                                    {contentToRender[0]?.body && parse(contentToRender[0]?.body)}
                                </div>

                                {contentToRender[0]?.content_buttons.length > 0 &&
                                    contentToRender[0]?.content_buttons.map((v, i) => (
                                        <CustomLink to={getLink(v.action)} key={v.label}>
                                            <div className="mt-4" key={i}>
                                                <Button className={i === 0 ? "button" : "button2"}>
                                                    {v.label}
                                                    <i className="pi pi-angle-right ml-4"></i>
                                                </Button>
                                            </div>
                                        </CustomLink>
                                    ))}
                            </div>
                        </div>

                        <div className="col-md-8 col-lg-8 col-sm-12 col-12 pr-0">
                            <Swiper dir={direction} key={direction} {...swiperCarousel}>
                                {contentReferenceData.map((value) => (
                                    <SwiperSlide key={value}>
                                        <div className="newsCard card">
                                            <div className="cardImg">
                                                <Link
                                                    to={getLink(
                                                        value?.path,
                                                        value?.type,
                                                        value?.language,
                                                        value?.link,
                                                    )}
                                                    target={getTargetFromType(
                                                        value?.type,
                                                        value?.link,
                                                    )}
                                                >
                                                    <ImageWithObjectFit
                                                        className="cursor-pointer"
                                                        src={value.image.src ? value.image.src : ""}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="card-body flex flex-col text-start">
                                                <div className="theme mb-2">
                                                    {getTheme(value?.breadcrumb)}
                                                </div>
                                                <Link
                                                    to={getLink(
                                                        value?.path,
                                                        value?.type,
                                                        value?.language,
                                                        value?.link,
                                                    )}
                                                    target={getTargetFromType(
                                                        value?.type,
                                                        value?.link,
                                                    )}
                                                >
                                                    <h3
                                                        className="hover:underline"
                                                        style={{ color: colorObj?.accent_color1 }}
                                                    >
                                                        {value?.title}
                                                    </h3>
                                                </Link>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FeaturedCard;
